module.exports = __webpack_public_path__ + "static/UK-Great-26debc6ca76611d5ee75ac4fc8f64fe2.png";